import { render } from "./DeliveryModeSelector.vue?vue&type=template&id=008c80c2"
import script from "./DeliveryModeSelector.vue?vue&type=script&lang=js"
export * from "./DeliveryModeSelector.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__